import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { ValidateCSVAndUpdateQuestionOptionsRPC } from "./validateCsvAndUpdateQuestionOptionsRPC";

export class ValidateCSVAndUpdateQuestionOptionsRPCClientImpl extends ValidateCSVAndUpdateQuestionOptionsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: ValidateCSVAndUpdateQuestionOptionsRPC.Request): Promise<LeoRPCResult<ValidateCSVAndUpdateQuestionOptionsRPC.Response, ValidateCSVAndUpdateQuestionOptionsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey/ValidateCSVAndUpdateQuestionOptions",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      ValidateCSVAndUpdateQuestionOptionsRPC.ResponseDTO,
      ValidateCSVAndUpdateQuestionOptionsRPC.Errors.ErrorsDTO,
      ValidateCSVAndUpdateQuestionOptionsRPC.Response,
      ValidateCSVAndUpdateQuestionOptionsRPC.Errors.Errors
    >(
      response,
      "survey/ValidateCSVAndUpdateQuestionOptions",
      ValidateCSVAndUpdateQuestionOptionsRPC.Response.fromDTO,
      ValidateCSVAndUpdateQuestionOptionsRPC.Errors.fromDTO
    );
  }
}
